import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Stat and StatRow, the dashboard number tile.
 *
 * Source selectors: `system.css` `.dsk-stat`, `.dsk-stat__label`,
 * `.dsk-stat__value`, `.dsk-stat-row`.
 *
 * Doctrine enforced:
 * - The label is muted and small, the value is bold and `tabular-nums`, so a
 *   row of four tiles keeps its digits on one vertical rhythm as they change.
 * - Same tone-lift surface as `Card`: no border, no shadow.
 * - Prices are Rands with an `R` prefix, never a dollar sign. This component
 *   does not format currency, it renders what you hand it, so format upstream
 *   and keep the `R`.
 *
 * `children` is the slot under the value, which is where a `Delta` goes.
 */
export const Stat = React.forwardRef(function Stat(
  { label, value, children, className, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={cn('dsk-stat', className)} {...rest}>
      {label ? <div className="dsk-stat__label">{label}</div> : null}
      {value !== undefined && value !== null ? (
        <div className="dsk-stat__value">{value}</div>
      ) : null}
      {children}
    </div>
  );
});
Stat.displayName = 'Stat';

/**
 * StatRow, `.dsk-stat-row`. A four-column grid of `Stat` tiles.
 * The track count is fixed at 4 upstream; hand it four, or override the grid
 * from the outside through `className`.
 */
export const StatRow = React.forwardRef(function StatRow({ className, ...rest }, ref) {
  return <div ref={ref} className={cn('dsk-stat-row', className)} {...rest} />;
});
StatRow.displayName = 'StatRow';

export default Stat;
